import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, interval, Observable, of, Subscription } from 'rxjs';
import { catchError, map, switchMap, startWith, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CheckConnectionService {
  private http = inject(HttpClient);

  private connectionStatus = new BehaviorSubject<boolean>(true);
  connectionStatus$ = this.connectionStatus.asObservable();
  private apiUrl = 'api/sessionTest';
  private intervalSubscription: any = null;

  constructor() {
    console.log('*** ConnectionService constructor');
    
  }
  startCheckingConnection() {
    if (this.intervalSubscription === null) {
      // Start polling the API
      this.intervalSubscription = interval(1000) // Check every seconds (adjust as needed)
      .pipe(
        startWith(0), // Immediately perform a check on init
        switchMap(() => this.checkConnection()),
        tap(isOnline => {
          // emit change only if the status has change
          const currentStatus = this.connectionStatus.getValue();
          if (isOnline !== currentStatus) {
            this.connectionStatus.next(isOnline);
          }
        })
      )
      .subscribe();
    }
  }

  stopCheckingConnnection() {
    if (this.intervalSubscription !== null) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
      console.log("Stop checking connection");
    }
  }

  private checkConnection(): Observable<boolean> {
    console.log('*** ConnectionService checkConnection');
    return this.http.get(this.apiUrl, { responseType: 'text' }).pipe(
      // tap((response) => {
      //   console.log('tap, response: ', response);
      // }),
      map((response) => {
        // console.log('map, response: ', response);
        return response === 'OK'
      }),
      catchError(error => {
        // console.error('Connection check failed:', error.message, error);
        return of(false); // Assume offline on error
      })
    );
  }
}
